import { baseViewModelToViewModelConverter } from "./converter";
import { useSiteControllerSettingTLLincolnFormModelMethods } from "./methods";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useCreateSiteControllerSettingTlLincolnFormModel = ({
	viewModel: baseViewModel,
	onSetViewModel,
}: Props) => {
	const { viewModel: tlLincolnViewModel } = baseViewModelToViewModelConverter({ viewModel: baseViewModel });

	return {
		tlLincolnViewModel,
		...useSiteControllerSettingTLLincolnFormModelMethods({
			viewModel: baseViewModel,
			onSetViewModel,
		}),
	};
};
